// extracted by mini-css-extract-plugin
export default {"root":"DarkstoreStatusPanel_root__YG+NZ"};